'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _immutable = require('immutable');

var _Availability2 = require('MeetingsBase/models/Availability');

var _Availability3 = _interopRequireDefault(_Availability2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function toMilliseconds(availability) {
  return availability.reduce(function (reduction, day, key) {
    return reduction.set(key, day.map(function (timeRange) {
      return timeRange.toMilliseconds();
    }));
  }, new _immutable.Map());
}

var AvailabilityMilliseconds = function (_Availability) {
  _inherits(AvailabilityMilliseconds, _Availability);

  function AvailabilityMilliseconds() {
    _classCallCheck(this, AvailabilityMilliseconds);

    return _possibleConstructorReturn(this, (AvailabilityMilliseconds.__proto__ || Object.getPrototypeOf(AvailabilityMilliseconds)).apply(this, arguments));
  }

  _createClass(AvailabilityMilliseconds, null, [{
    key: 'from',
    value: function from(data) {
      if (!data || Object.keys(data).length === 0) {
        return new AvailabilityMilliseconds(_get(AvailabilityMilliseconds.__proto__ || Object.getPrototypeOf(AvailabilityMilliseconds), 'from', this).call(this, data));
      }

      return this.fromAvailability(_Availability3.default.from(data));
    }
  }, {
    key: 'fromAvailability',
    value: function fromAvailability(availability) {
      /**
      * @param {Availability} availability Configured weekly availability
      * @returns {AvailabilityMilliseconds} Configured weekly availability, expressed in
      * millisecond timestamps
      */
      if (!availability || Object.keys(availability).length === 0) {
        return new AvailabilityMilliseconds();
      }
      var availabilityInMilliseconds = toMilliseconds(availability);
      return new AvailabilityMilliseconds(availabilityInMilliseconds);
    }
  }]);

  return AvailabilityMilliseconds;
}(_Availability3.default);

exports.default = AvailabilityMilliseconds;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/models/AvailabilityMilliseconds.js
// module id = 185
// module chunks = 0